import React from "react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";

import Footer from "../includes/home/Footer";
import Spotlight from "../includes/home/Spotlight";
import About from "../includes/home/About";
import Learning from "../includes/home/Learning";
import Provide from "../includes/home/Provide";
import GetInTouch from "../includes/home/GetInTouch";

function Home({ isModal, closeFunction, number }) {
  return (
    <>
      <Helmet>
        <title>English Cafe | Home</title>
      </Helmet>

      <Spotlight
        isModal={isModal}
        closeFunction={closeFunction}
        number={number}
      />

      <About />
      <Learning />
      <Provide />
      <GetInTouch />
      <Footer />
      <Outlet />
    </>
  );
}

export default Home;
